import { createContext } from 'react'

import { DESKTOP_WIDTH } from '../constants/screen'

export const Screen = createContext({
  isMobileScreenSize: false,
  width: DESKTOP_WIDTH,
})
